export const GET_NUCLEAR_DOCUMENT = 'GET_NUCLEAR_DOCUMENT'
export const NUCLEAR_DOC_LOADING = 'NUCLEAR_DOC_LOADING'
export const RESET_NUCLEAR_MODAL = 'RESET_NUCLEAR_MODAL'
export const CLEAR_NUCLEAR = 'CLEAR_NUCLEAR'
